import styles from './SignIn.module.css';

interface GoodbyeProps {
  onSignIn: () => void;
}

/**
 * R207 (Jason: "on sign out needs to auto out to the goodbye page — we don't
 * have it yet"). The sign-out landing: useAuth.signOut hard-navigates here
 * after POST /auth/logout, so a signed-out user never strands on a dead
 * authed screen (the live repro: Settings full of "Not signed in" cards).
 * Deliberately shares SignIn.module.css — same visual family as the front
 * door, one source of truth, zero style drift. Rendered by App.tsx via
 * shouldRenderGoodbye() BEFORE the signed-out SignIn gate.
 */
export function Goodbye({ onSignIn }: GoodbyeProps) {
  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.avatar}>M</div>
        <div className={styles.title}>See you soon.</div>
        <div className={styles.body}>
          You're signed out. Your story, your words, and everything you've built here stay safe —
          right where you left them.
        </div>
        <button type="button" className={styles.googleButton} onClick={onSignIn}>
          Sign back in
        </button>
      </div>
    </div>
  );
}
